<template>
  <div class="detailBox">
    <ul class="detailContent">
      <el-form :model="state.model" label-width="100px" style="width: 100%" :scroll-to-error="true" ref="formDom">
        <el-form-item label="状态" prop="IsQy">
          <el-switch v-model="state.model.IsQy" />
        </el-form-item>
        <el-form-item label="日期" prop="RiQi"
          :rules="[{ required: true, message: '请选择日期', trigger: 'blur' }]">
          <el-date-picker v-model="state.model.RiQi" type="date" placeholder="选择日期"
            value-format="YYYY-MM-DD" style="width: 220px" />
        </el-form-item>
        <el-form-item label="时段名称" prop="ShiDuanMc"
          :rules="[{ required: true, message: '请输入时段名称', trigger: 'blur' }]">
          <el-input v-model="state.model.ShiDuanMc" placeholder="选择时间后自动填充，也可手动修改" style="width: 220px"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="Kssj"
          :rules="[{ required: true, message: '请选择开始时间', trigger: 'blur' }]">
          <el-time-select v-model="state.model.Kssj" start="00:00" end="23:30" step="00:30"
            placeholder="选择开始时间" style="width: 220px" />
        </el-form-item>
        <el-form-item label="结束时间" prop="Jzsj"
          :rules="[{ required: true, message: '请选择结束时间', trigger: 'blur' }]">
          <el-time-select v-model="state.model.Jzsj" start="00:00" end="23:30" step="00:30"
            placeholder="选择结束时间" style="width: 220px" />
        </el-form-item>
        <el-form-item label="总库存" prop="Zkc">
          <el-input-number v-model="state.model.Zkc" :min="0" controls-position="right" style="width: 220px" />
        </el-form-item>
        <el-form-item label="排序" prop="Px">
          <el-input-number v-model="state.model.Px" :min="0" controls-position="right" style="width: 220px" />
        </el-form-item>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch, getCurrentInstance } from "vue";
import { menpiao_shiduan_detail, menpiao_shiduan_add, menpiao_shiduan_edit } from "@/http/api";

export default {
  props: { id: Number, spId: Number, gzId: Number, tcId: Number },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const state = reactive({ model: { IsQy: true, Px: 0, Zkc: 0, ShiDuanMc: '', GzId: props.gzId || 0, TcId: props.tcId || 0 } });

    onMounted(() => {
      if (props.id) {
        menpiao_shiduan_detail(props.id).then((res) => {
          if (res.status == 200) {
            const d = res.data;
            state.model = {
              ...state.model,
              ...d,
              RiQi: d.RiQi ? d.RiQi.substring(0, 10) : '',
              Kssj: d.Kssj ? d.Kssj.substring(0, 5) : '',
              Jzsj: d.Jzsj ? d.Jzsj.substring(0, 5) : '',
            };
          }
        });
      }
    });

    // 监听开始/结束时间变化，自动拼接时段名称
    watch(
      () => [state.model.Kssj, state.model.Jzsj],
      ([kssj, jzsj]) => {
        if (kssj && jzsj) {
          state.model.ShiDuanMc = kssj + '-' + jzsj;
        }
      }
    );

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return;
        const submitData = { ...state.model };
        submitData.Kssj = submitData.Kssj ? submitData.Kssj + ':00' : '00:00:00';
        submitData.Jzsj = submitData.Jzsj ? submitData.Jzsj + ':00' : '00:00:00';

        if (props.id) {
          menpiao_shiduan_edit(props.id, submitData).then((res) => proxy.$post_response(res, emit));
        } else {
          menpiao_shiduan_add(props.spId, submitData, props.gzId, props.tcId).then((res) => proxy.$post_response(res, emit));
        }
      });
    };

    return { state, formDom, onSubmit };
  },
};
</script>
<style scoped lang="less">
:deep(.el-input-number .el-input__inner) {
  text-align: left;
}
</style>
